module.exports = __webpack_public_path__ + "assets/img/num-02-ba7b1470.png";